import { LoaderFunctionArgs, redirect, ShouldRevalidateFunction } from 'react-router-dom'
import { URLS, SAGA_ACTIONS } from '.'
import { store } from '../store'

// Type for the loader response
export interface AuthLoaderData {
    isAuth: boolean
    user?: any
}

// Auth check shouldRevalidate function
export const shouldRevalidateAuth: ShouldRevalidateFunction = ({ currentParams, nextParams, defaultShouldRevalidate }) => {
    // Always revalidate auth status on navigation
    return true
}

// Auth loader for protected routes
export function authLoader({ request }: LoaderFunctionArgs): AuthLoaderData {
    const state = store.getState()
    const isAuth = state.user?.isAuthenticated
    const user = state.user?.user
    if (!isAuth) {
        throw redirect(URLS.HOME)
    }

    return { isAuth, user }
}

// Public routes loader with auth redirect
export function publicLoader({ request }: LoaderFunctionArgs): AuthLoaderData {
    const state = store.getState()
    const isAuth = state.user?.isAuthenticated
    const user = state.user?.user

    if (isAuth) {
        throw redirect(URLS.MY_EXPERIMENTS)
    }

    return { isAuth, user }
}

// Type for experiment data
export interface ExperimentLoaderData {
    experiment: any
    user?: any
}

// Experiment details loader
export async function experimentDetailsLoader({ params }: LoaderFunctionArgs): Promise<ExperimentLoaderData> {
    const experimentId = params.id
    if (!experimentId) {
        throw new Error('Experiment ID is required')
    }

    return new Promise((resolve, reject) => {
        store.dispatch({
            type: SAGA_ACTIONS.EXPERIMENT.GET_EXPERIMENT_DETAILS,
            payload: {
                literal: experimentId,
                use_orm: true,
            },
            onSuccess: (response: any) => {
                const state = store.getState()
                resolve({
                    experiment: response.data,
                    user: state.user?.user,
                })
            },
            onError: (error: any) => {
                // console.error('Error loading experiment:', error)
                //reject(error)
                // ✅ Changed: Added proper error handling with null check
                const errorMessage = error?.message || 'Failed to load experiment details'
                console.error('Error loading experiment:', errorMessage, error)
                reject(new Error(errorMessage))
            },
        })
    })
}
